/** Decorative sleeping pillows in inches; Full uses a smaller pair. */
export function pillowLayout(mattressWidth:number){
 const count= mattressWidth>=50?2:1;
 const width=Math.min(mattressWidth-4,count===1?26:mattressWidth<58?24:26);
 const depth=width*20/26;
 const gap=count===2?2:0;
 const offsets=Array.from({length:count},(_,i)=>(i-(count-1)/2)*(width+gap));
 return {count,width,depth,offsets};
}
export const PILLOW_OUTLINE='M2 1 Q10 -1 18 1 Q21 13 18 25 Q10 27 2 25 Q-1 13 2 1Z';
